import { useState } from 'react'
import PrimaryButton from '../../global/components/buttons/primary-button/PrimaryButton'
import LocationDropDown from '../../global/components/location-drop-down/LocationDropDown'
import { TextField } from '@mui/material'
import styles from './styles.module.css'
import { fetchData } from '../../global/utils/fetch'
import { adjustDeliveryCandidateStatuses } from '../api'
import { formatDateYyyyMmDd } from '../../global/utils/date/date-utils-yyyy-mm-dd'

interface AdjustmentResponse {
  success: boolean
  message: string
  updatedCount: number
  locationName: string
  date: string
}

export default function AdjustDeliveryCandidateStatuses() {
  const [form, setForm] = useState({
    locationObjectId: '',
    date: formatDateYyyyMmDd(new Date()),
  })
  const [loading, setLoading] = useState(false)

  async function onAdjustClick() {
    const { locationObjectId, date } = form
    if (!locationObjectId) return alert('Please select a location')
    if (!date) return alert('Please select a date')

    setLoading(true)
    try {
      const response = (await fetchData(
        adjustDeliveryCandidateStatuses(locationObjectId, date),
      )) as AdjustmentResponse
      alert(
        `✅ Adjustment complete! ${response.updatedCount} delivery candidates updated from "candidate-rejected" to "awaiting-scheduling" for ${response.locationName} on ${response.date}`,
      )
    } catch (error: any) {
      console.error(error)
      alert(`❌ Adjustment failed: ${error.message}`)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className={styles.toolContainer}>
      <h2>Adjust Delivery Candidate Statuses</h2>
      <p className={styles.toolDescription}>
        Convert all "candidate-rejected" delivery candidates to
        "awaiting-scheduling" for a specific location and date
      </p>

      <div className={styles.formContainer}>
        <LocationDropDown
          onLocationChange={(locationObjectId: string) =>
            setForm({ ...form, locationObjectId })
          }
          defaultValue={form.locationObjectId}
        />

        <TextField
          type='date'
          label='Date'
          name='date'
          value={form.date}
          onChange={(e) => setForm({ ...form, date: e.target.value })}
          InputLabelProps={{ shrink: true }}
          fullWidth
        />

        <div className={styles.buttonContainer}>
          <PrimaryButton
            buttonName={loading ? 'Adjusting...' : 'Adjust Statuses'}
            onClick={onAdjustClick}
            disabled={loading}
          />
        </div>
      </div>
    </div>
  )
}
